import React from 'react'
import { useIntl } from 'react-intl'
import { Box } from '@mui/material'
import { H3 } from '../../../layouts/TextStyles'
import { useHeadFilters } from '../../head/headData'
import { ui } from '../../../utils/uiTokens'
import PsReportView from './PsReportView'
import RatingReportView from './RatingReportView'
import { MentorFilters, page } from './shared'

const Shell: React.FC<{ title: string; sub: string; children: React.ReactNode }> = ({ title, sub, children }) => (
    <Box sx={{ margin: { xs: '6px', md: '10px' } }}>
        <Box sx={page}>
            <H3>{title}</H3>
            <Box sx={{ color: ui.sub, fontSize: '13.5px', margin: '6px 0 18px' }}>{sub}</Box>
            {children}
        </Box>
    </Box>
)

// Ментор: «ПС есебі» - запись, посещение и итог по каждой из двух практик недели
export const MentorPsReportPage = () => {
    const { formatMessage } = useIntl()
    const f = useHeadFilters()
    return (
        <Shell title={formatMessage({ id: 'mrPsTitle' })} sub={formatMessage({ id: 'mrPsSub' })}>
            <MentorFilters f={f} />
            <PsReportView f={f} />
        </Shell>
    )
}

// Ментор: «Рейтинг есебі» - отстающие, что сделано, план на неделю
export const MentorRatingReportPage = () => {
    const { formatMessage } = useIntl()
    const f = useHeadFilters()
    return (
        <Shell title={formatMessage({ id: 'mrRatingTitle' })} sub={formatMessage({ id: 'mrRatingSub' })}>
            <MentorFilters f={f} />
            <RatingReportView f={f} />
        </Shell>
    )
}
